var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Link',{staticClass:"botao",class:_vm.contents.content.alignment || 'left',attrs:{"contents":_vm.contents.content}},[_vm._v(_vm._s(_vm.contents.content.name))])}
var staticRenderFns = []

export { render, staticRenderFns }